// ExpertConnect.jsx
import React, { useState } from 'react';
import {
  Users,
  ArrowRight,
  Star,
  Clock,
  Award,
  Briefcase,
  User,
  Mail,
  Phone,
  MapPin,
  CheckCircle,
  Sparkles,
  Shield,
  Zap,
  Search,
  Filter,
  TrendingUp,
  Crown,
  MessageCircle,
  Calendar
} from 'lucide-react';
import './ExpertConnect.css';
import Navbar from './Navbar';
import WhyConsultFirst from'./WhyConsultFirst';
import Expertteam from './Expertteam';
import CTA from './CTA'
import Footer from './Footer';

const ExpertConnect = () => {
  const [activeTab, setActiveTab] = useState('all');

  const experts = [
    {
      id: 1,
      name: "Ravi Kumar",
      role: "CAD & DFM Expert",
      experience: "15 yrs",
      rate: "₹500",
      rating: 4.9,
      reviews: 127,
      avatar: "RK",
      expertise: ["CAD Modeling", "DFM Analysis", "3D Printing"],
      availability: "Available Now",
      verified: true,
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=center&auto=format&q=80"
    },
    {
      id: 2,
      name: "Priya Sharma",
      role: "Product Design Engineer",
      experience: "10 yrs",
      rate: "₹650",
      rating: 4.8,
      reviews: 98,
      avatar: "PS",
      expertise: ["Product Design", "Prototyping", "3D Modeling"],
      availability: "Busy",
      verified: true,
      image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop&crop=center&auto=format&q=80"
    },
    {
      id: 3,
      name: "Amit Patel",
      role: "Manufacturing Specialist",
      experience: "12 yrs",
      rate: "₹750",
      rating: 4.7,
      reviews: 85,
      avatar: "AP",
      expertise: ["Manufacturing", "Process Optimization", "Quality Control"],
      availability: "Available Now",
      verified: true,
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=center&auto=format&q=80"
    }
  ];

  const stats = [
    { value: "500+", label: "Experts" },
    { value: "4.8", label: "Avg Rating" },
    { value: "95%", label: "Success Rate" },
    { value: "50+", label: "Expertise Areas" }
  ];

  return (
    <>
    <Navbar/>
    <section className="expert-connect">
      <div className="expert-container">
        {/* ========== HERO SECTION ========== */}
        <div className="expert-hero">
          {/* Left Side - Text Content */}
          <div className="expert-hero-left">
            <div className="expert-badge">
              <Sparkles size={16} className="expert-badge-icon" />
              <span>Expert Network</span>
            </div>

            <h1 className="expert-hero-title">
              <span className="expert-hero-title-line1">The right expertise can turn</span>
              <span className="expert-hero-title-line2">a good idea into a great product.</span>
            </h1>

            <p className="expert-hero-description">
              Every successful prototype starts with the right technical decisions. 
              APIC ProtoHub connects innovators with engineers, product designers, 
              manufacturing specialists and technology experts who help transform 
              ideas into technically feasible, manufacturable, cost-effective products.
            </p>

            {/* CTA Buttons */}
            <div className="expert-hero-cta">
              <button className="expert-cta-primary">
                <Search size={18} />
                <span>Find an Expert</span>
                <ArrowRight size={18} className="expert-cta-arrow" />
              </button>
              <button className="expert-cta-secondary">
                <User size={18} />
                <span>Become an Expert</span>
              </button>
              <button className="expert-cta-outline">
                <LogIn size={18} />
                <span>Login</span>
              </button>
            </div>

            {/* Stats */}
            <div className="expert-stats">
              {stats.map((stat, index) => (
                <React.Fragment key={index}>
                  <div className="expert-stat-item">
                    <p className="expert-stat-value">{stat.value}</p>
                    <p className="expert-stat-label">{stat.label}</p>
                  </div>
                  {index < stats.length - 1 && (
                    <div className="expert-stat-divider"></div>
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>

          {/* Right Side - Image */}
          <div className="expert-hero-right">
            <div className="expert-hero-image-wrapper">
              <img
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&h=600&fit=crop&crop=center&auto=format&q=80"
                alt="Expert team collaboration"
                className="expert-hero-image"
                loading="lazy"
              />
              
              {/* Floating Card */}
              <div className="expert-float-card">
                <div className="expert-float-icon">
                  <Users size={18} />
                </div>
                <div>
                  <p className="expert-float-title">500+ Experts</p>
                  <p className="expert-float-desc">Ready to help you</p>
                </div>
              </div>

              {/* Rating Badge */}
              <div className="expert-rating-badge">
                <div className="expert-rating-stars">
                  <Star size={14} fill="#f59e0b" stroke="#f59e0b" />
                  <span className="expert-rating-value">4.8</span>
                </div>
                <p className="expert-rating-label">Average Rating</p>
              </div>
            </div>
          </div>
        </div>

        {/* ========== EXPERTS SECTION ========== */}
       
        
      </div>
    </section>
     <Expertteam/>

    <WhyConsultFirst/>
    <Footer/>
    </>
  );
};

// LogIn icon component
const LogIn = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
    <polyline points="10 17 15 12 10 7"/>
    <line x1="15" y1="12" x2="3" y2="12"/>
  </svg>
);

export default ExpertConnect;